






















import Vue from 'vue';
import SignupForm from '../components/SignupForm.vue';
import Navbar from '../components/Navbar.vue';

export default Vue.extend({
  name: 'signup',
  components: {
    SignupForm,
    Navbar
  },
  data: () => ({
    height: "700",
  }),
  methods: {},
  mounted() {
    if (this.$parent.$el.clientHeight) {
      this.height = this.$parent.$el.clientHeight * 0.9;
    }
  }
});
